/**
 * Sidebar Item Icon
 *
 * Holds shared sidebar icon sizing constants used outside the SidebarItem
 * render module.
 *
 * Primary responsibilities:
 * - Export shared sidebar icon size constants
 * - Avoid importing the full sidebar item renderer for simple constants
 *
 * Dependencies:
 * - none
 */

export const SIDEBAR_ITEM_ICON_SIZE = 23
export const SIDEBAR_ITEM_ICON_STROKE = 1.5
